const tardyRegistrationReasons = {
  EstudianteSeEvaluoFuera30Dias: 1,
  AusenciasRecurrentesPorPartePadresReunionDeterminacionElegibilidad: 7,
  Otros: 9,
  AusenciaRecurrentePorPartePadresEvaluacionInicial: 19,
};

export default tardyRegistrationReasons;
